var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Total > 0)?_c('div',{staticClass:"custom-pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.Page,"page-sizes":[12, 24, 48, 96],"page-size":_vm.PageSize,"layout":"sizes, total, prev, pager, next, jumper","total":_vm.Total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }